import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GatesMonitoringModule } from './gates-monitoring.module';

@NgModule({
  imports: [CommonModule, GatesMonitoringModule],
})
export class ArrivalModule {}
